<main class="px-5"
      ucbUiMasterHeader
      #header="header"
      [style.padding-top.px]="header.offset">
  <router-outlet/>
</main>
<router-outlet name="modal"/>

<wbs-global-loader/>
<wb-ui-toast/>
<wbs-chat-button/>